import { makeStyles } from '@material-ui/core';

export const MemberTypeRadioGroupStyle = makeStyles({
    root: {
        padding: '16px 16px 0 16px',
    },
});
